import { render, staticRenderFns } from "./b-ticket-policies.vue?vue&type=template&id=7d6fdd81&scoped=true"
import script from "./b-ticket-policies.vue?vue&type=script&lang=ts"
export * from "./b-ticket-policies.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-policies.vue?vue&type=style&index=0&id=7d6fdd81&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6fdd81",
  null
  
)

export default component.exports